import React, { useEffect, useState } from 'react'

import LineChart from '@professocial/professocialChartComponents/ChartComponents/LineChart'
import { hexToRGB } from '../../../../util/transformColor'
import { IUserStatisticData } from '../../../types/types'
import { ChartData } from 'chart.js'

const PageStats: React.FC<IUserStatisticData> = (props) => {
  const [chartData, setChartData] = useState<ChartData | undefined>(props.data)

  useEffect(() => {
    props.data && createChartData(props.data)
  }, [props.data])

  /**
   * The following data gets chosen at random from the delivered possible values
   */
  const createChartData = (statisticsObj: ChartData) => {
    if (statisticsObj.datasets && statisticsObj.datasets.length > 0) {
      setChartData({
        labels: statisticsObj.labels,
        datasets: statisticsObj.datasets.map((dataset, index: number) => {
          return ({
            label: dataset.label,
            fill: true,
            data: dataset.data,
            backgroundColor: hexToRGB(props.colors[index + 1], 0.7),
            borderColor: props.colors[index + 1],
            pointStyle: 'circle',
            pointRadius: 4,
            pointHoverRadius: 6,
            lineTension: 0,
          })
        }),
      })
    }
  }

  return (
    <div style={{ position: 'relative', margin: 'auto', height: '440px', width: '95%' }}>
      <LineChart
        type='line'
        data={chartData as ChartData<'line'>}
        height={100}
        options={{
          responsive: true,
          maintainAspectRatio: false
        }}
      />
    </div>
  )
}
export default PageStats
